import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import ListInquiry from "../../components/ListInquiry";
import Grid from '@mui/material/Grid';
import "./style.css";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "../../pages/PIList/api.js";
import {readEmpty} from "../../pages/PIList/apiEmpty.js";
import Post from "../../pages/PIList/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { useSelector } from 'react-redux';

export default function CreatePost(){

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
    }, [skip,query]);

    async function newPI(e){
        history("/proformainvoice",{state:{stuff:"new"}})

    }

    const nowstate = useSelector(state => state);


    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis,nowstate.user.sales);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    console.log(data)

                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            console.log(data)

            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdf?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    window.open(fileURLNew, '_blank');
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value,searchThis,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            console.log(data)

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...data])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)

                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }

    const searchSelected = async (event)=>{
        setsearchThis(event.target.value)
        if(query.trim()){
            try{
                const { data, error } = await read(skip,query,event.target.value,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            }
            }else{
                console.log("empty")
                try{
                    const { data, error } = await readEmpty(skip,nowstate.user.sales);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
            }
    }
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/proformainvoice",{state:{data:post, stuff:"edit"}})
        }else{
            history("/proformainvoice",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const addonPI = async (post)=>{
        if(currPreview === "none"){
            history("/proformainvoice", {state:{data:post,stuff:"addOn"}})
        }else{
            history("/proformainvoice", {state:{data:currPreview,stuff:"addOn"}})
        }
    }

    const [openPickInquiry, setOpenPickInquiry] = useState(false)
    const pickInquiry = () => {
        setOpenPickInquiry(true)
    }

    const closeOpenPickInquiry = () => {
        setOpenPickInquiry(false)
    }

    return <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog open={openPickInquiry} onClose={closeOpenPickInquiry}>
                    <ListInquiry></ListInquiry>
                </Dialog>
                    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="1200" height="500"></iframe>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button>
                        <EditIcon onClick={() => editPI()}></EditIcon>
                    </Button>
                    <Button>
                        <ReceiptIcon  onClick={() => addonPI()}></ReceiptIcon>
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                        <Header judul="Proforma Invoice" isi="Daftar semua Proforma Invoice"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={2}>
                            <Select  fullWidth value={searchThis} onChange={event => searchSelected(event)}><MenuItem value="billTo">Company</MenuItem><MenuItem value="shipTo">PIC</MenuItem><MenuItem value="piAmount">No. PI</MenuItem></Select>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField value={query} onChange={event => handleSearch(event)} fullWidth />
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={event => pickInquiry()}>Create +</Button>
                        </Grid>
                        </Grid>

                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Tanggal
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (Company)
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (PIC)
                                                </TableCell>
                                                <TableCell>
                                                    Nomor PI
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.tanggalPI}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.billTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.shipTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.piAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" onClick={() => editPI(post)}>
                                                            <EditIcon></EditIcon>
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" onClick={() => addonPI(post)}>
                                                            <ReceiptIcon></ReceiptIcon>
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
    };

